import { faChevronDown, faChevronUp } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
const GalleryControl = ({ images = [], onClick, initialIndex = 0, size = null, shadow = false, colors = {
    borderColor: "border-gray-200",
}, }) => {
    const [swiperInstance, setSwiperInstance] = useState();
    const [imageList, setImageList] = useState([]);
    const [activeIndex, setActiveIndex] = useState(initialIndex);
    const [selectedImage, setSelectedImage] = useState(images.length > 0 ? images[0] : undefined);
    useEffect(() => {
        setImageList(images);
        setSelectedImage(images[initialIndex]);
    }, [images]);
    const determineSelectedImageSize = (size) => {
        switch (size) {
            case "small":
                return "h-64 w-64";
            case "medium":
                return "h-80 w-80";
            case "large":
                return "h-96 w-96";
            default:
                return "h-full w-96";
        }
    };
    const determineSliderSize = (size) => {
        switch (size) {
            case "small":
                return "h-64 w-22";
            case "medium":
                return "h-80 w-18";
            case "large":
                return "h-96 w-18";
            default:
                return "h-full w-96";
        }
    };
    const determineSlidesPerView = (size) => {
        switch (size) {
            case "small":
                return 2;
            case "medium":
                return 3;
            case "large":
                return 4;
            default:
                return 4;
        }
    };
    return (React.createElement("div", { className: `relative flex flex-row gap-2` },
        React.createElement("div", { className: `flex-none ${determineSelectedImageSize(size)} rounded-lg border ${colors.borderColor} overflow-clip ${shadow ? `shadow-lg ${colors?.shadowColor}` : ""}` }, selectedImage && React.createElement("img", { className: "w-full h-full object-cover", src: selectedImage?.url })),
        imageList && imageList.length > 1 && (React.createElement("div", { className: `flex-none relative ${determineSliderSize(size)} flex flex-col` },
            React.createElement("div", { className: "flex-none h-10 flex justify-center items-center cursor-pointer select-none", onClick: () => {
                    swiperInstance.slidePrev();
                } },
                React.createElement(FontAwesomeIcon, { icon: faChevronUp })),
            React.createElement("div", { className: "flex-1 relative overflow-hidden" },
                React.createElement(Swiper, { className: "h-full", initialSlide: initialIndex, modules: [Autoplay], slidesPerView: determineSlidesPerView(size), direction: "vertical", loop: imageList.length > determineSlidesPerView(size) ? true : false, onSwiper: (swiper) => {
                        setSwiperInstance(swiper);
                    }, onSlideChange: (swiper) => {
                        setActiveIndex(swiper.activeIndex);
                    } }, imageList.map((image, index) => {
                    return (React.createElement(SwiperSlide, { key: `gallery-item-${index}`, className: "", onClick: () => {
                            setSelectedImage(image);
                            if (onClick) {
                                onClick();
                            }
                        } },
                        React.createElement("div", { className: "h-full w-full p-1" },
                            React.createElement("img", { className: "rounded-lg w-full h-full object-cover", src: image.url }))));
                }))),
            React.createElement("div", { className: "flex-none h-10 flex justify-center items-center cursor-pointer select-none", onClick: () => {
                    swiperInstance.slideNext();
                } },
                React.createElement(FontAwesomeIcon, { icon: faChevronDown }))))));
};
export { GalleryControl };
